// extracted by mini-css-extract-plugin
export default {"copyButton":"hyperlinked-text_copyButton__ibzw0"};